import api from '../config/api';
import { ProduitCatalogue, ProduitCatalogueRequestDTO } from '../types';

/**
 * Service pour gérer le catalogue de produits
 */

// Récupérer tous les produits du catalogue
export const getAllProduits = async (): Promise<ProduitCatalogue[]> => {
  const response = await api.get('/produits-catalogue');
  return response.data;
};

// Récupérer un produit par ID
export const getProduitById = async (id: number): Promise<ProduitCatalogue> => {
  const response = await api.get(`/produits-catalogue/${id}`);
  return response.data;
};

// Créer un nouveau produit
export const createProduit = async (data: ProduitCatalogueRequestDTO): Promise<ProduitCatalogue> => {
  const response = await api.post('/produits-catalogue', data);
  return response.data;
};

// Mettre à jour un produit
export const updateProduit = async (id: number, data: ProduitCatalogueRequestDTO): Promise<ProduitCatalogue> => {
  const response = await api.put(`/produits-catalogue/${id}`, data);
  return response.data;
};

// Supprimer un produit
export const deleteProduit = async (id: number): Promise<void> => {
  await api.delete(`/produits-catalogue/${id}`);
};

// Rechercher des produits par mot-clé
export const searchProduits = async (keyword: string): Promise<ProduitCatalogue[]> => {
  const response = await api.get('/produits-catalogue/search', {
    params: { keyword },
  });
  return response.data;
};

// Rechercher par catégorie
export const getProduitsByCategorie = async (categorie: string): Promise<ProduitCatalogue[]> => {
  const response = await api.get(`/produits-catalogue/categorie/${categorie}`);
  return response.data;
};

// Rechercher par type consommable
export const getProduitsByTypeConsommable = async (type: string): Promise<ProduitCatalogue[]> => {
  const response = await api.get(`/produits-catalogue/consommable/${type}`);
  return response.data;
};

// Récupérer les produits en stock faible
export const getProduitsStockFaible = async (seuil: number = 10): Promise<ProduitCatalogue[]> => {
  const response = await api.get('/produits-catalogue/stock-faible', {
    params: { seuil },
  });
  return response.data;
};

// Compter le nombre de produits
export const countProduits = async (): Promise<number> => {
  const response = await api.get('/produits-catalogue/count');
  return response.data;
};

// Calculer les quantités pour une surface donnée
export const calculerQuantite = async (id: number, surface: number): Promise<any> => {
  const response = await api.get(`/produits-catalogue/${id}/calculer`, {
    params: { surface },
  });
  return response.data;
};

// Archiver un produit
export const archiverProduit = async (id: number): Promise<void> => {
  await api.patch(`/produits-catalogue/${id}/archiver`);
};

// Réactiver un produit
export const reactiverProduit = async (id: number): Promise<void> => {
  await api.patch(`/produits-catalogue/${id}/reactiver`);
};
